import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { LOGO_URL, WHATSAPP_URL } from "../../lib/constants";

const links = [
    { label: "Inicio", href: "#inicio" },
    { label: "Centros", href: "#centros" },
    { label: "Mujeres", href: "#mujeres" },
    { label: "Servicios", href: "#servicios" },
    { label: "Resultados", href: "#transformaciones" },
    { label: "Contacto", href: "#contacto" },
];

export default function Navbar() {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 30);
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <motion.nav
            data-testid="main-navbar"
            initial={{ y: -40, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6 }}
            className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
                scrolled
                    ? "bg-[#050505]/85 backdrop-blur-xl border-b border-white/5"
                    : "bg-transparent"
            }`}
        >
            <div className="max-w-7xl mx-auto px-5 md:px-10 py-3 flex items-center justify-between">
                <a
                    href="#inicio"
                    data-testid="nav-logo-link"
                    className="flex items-center gap-3 group"
                >
                    <img
                        src={LOGO_URL}
                        alt="F You Entrenadores"
                        className="h-12 w-12 object-contain"
                    />
                    <div className="hidden sm:block leading-none">
                        <div className="font-display text-xl tracking-tight text-brand-text">
                            F YOU
                        </div>
                        <div className="font-display text-[10px] text-brand-gold tracking-[0.35em]">
                            GESTIÓN DEPORTIVA
                        </div>
                    </div>
                </a>

                <ul className="hidden lg:flex items-center gap-8">
                    {links.map((l) => (
                        <li key={l.href}>
                            <a
                                href={l.href}
                                data-testid={`nav-link-${l.label.toLowerCase()}`}
                                className="text-sm uppercase tracking-widest text-brand-muted hover:text-brand-orange transition-colors duration-300"
                            >
                                {l.label}
                            </a>
                        </li>
                    ))}
                </ul>

                <div className="flex items-center gap-3">
                    <a
                        href={WHATSAPP_URL}
                        target="_blank"
                        rel="noreferrer"
                        data-testid="nav-cta-whatsapp"
                        className="hidden md:inline-flex items-center justify-center font-display tracking-wider text-sm bg-brand-orange hover:bg-brand-orangeHover text-black px-6 py-3 transition-all duration-300 hover:scale-[1.03]"
                    >
                        Empieza Hoy
                    </a>
                    <button
                        onClick={() => setOpen(!open)}
                        data-testid="nav-menu-toggle"
                        className="lg:hidden p-2 text-brand-text"
                        aria-label="Menú"
                    >
                        {open ? <X size={26} /> : <Menu size={26} />}
                    </button>
                </div>
            </div>

            <AnimatePresence>
                {open && (
                    <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        className="lg:hidden bg-[#050505] border-t border-white/5 overflow-hidden"
                    >
                        <ul className="px-6 py-6 space-y-5">
                            {links.map((l) => (
                                <li key={l.href}>
                                    <a
                                        href={l.href}
                                        onClick={() => setOpen(false)}
                                        data-testid={`mobile-nav-link-${l.label.toLowerCase()}`}
                                        className="font-display text-2xl tracking-tight text-brand-text hover:text-brand-orange transition-colors block"
                                    >
                                        {l.label}
                                    </a>
                                </li>
                            ))}
                            <li>
                                <a
                                    href={WHATSAPP_URL}
                                    target="_blank"
                                    rel="noreferrer"
                                    data-testid="mobile-cta-whatsapp"
                                    className="inline-block mt-2 bg-brand-orange text-black font-display tracking-wider px-6 py-3"
                                >
                                    Empieza Hoy
                                </a>
                            </li>
                        </ul>
                    </motion.div>
                )}
            </AnimatePresence>
        </motion.nav>
    );
}
